import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import { Loader } from "../_components/loader.component";
import { OrgCard } from "../_components/org-card.component";
import { OrganizationService } from "../_service/organization.service";
import { getOrganizationCommunityRoute } from "./organization-community-page";

export const COMMUNITY_MANAGEMENT_ROUTE = "/community-management";

function CommunityManagementPageComponent({ user, history, addToast }) {
  const [organizations, setOrganizations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getAllOrganizations();
  }, []);

  const getAllOrganizations = () => {
    setIsLoading(true);
    OrganizationService.getAllOrganizations(user)
      .then((resp) => {
        setOrganizations(resp);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  return (
    <div className="page-container ml-auto px-9 py-6 org-management-container">
      <div>
        <div className="bg-white card px-11 py-9 relative rounded-lg w-96 w-full">
          <div>
            <div className="flex justify-between">
              <p className="font-bold text-lg text-primary">
                Active Organizations
              </p>
            </div>
            {!isLoading ? (
              <div className="gap-y-10 grid mt-5 org-cards-container flex-wrap">
                {organizations && organizations.length > 0 ? (
                  organizations.map((org) => {
                    return (
                      <OrgCard
                        key={org._id}
                        orgDetails={org}
                        className="org-card"
                        onClick={(e) => {
                          history.push(getOrganizationCommunityRoute(org._id));
                        }}
                        btnLabel="Manage Groups"
                      />
                    );
                  })
                ) : (
                  <div>
                    <p className="text-primary">Organization data not found</p>
                  </div>
                )}
              </div>
            ) : (
              <Loader />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth,
});

const CommunityManagementPage = withToast(
  connect(mapStateToProps)(CommunityManagementPageComponent)
);

export default CommunityManagementPage;
